import { useCallback } from "react";
import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from "@mui/material";

import CascateList from "../../../../../../common/components/cascate_list";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DefaultInput from "../../../../../../common/components/default_input";

/**
 * Header
 */

type Props = {
  area: string;
  status: number;
  onAreaChange: (newValue: string) => void;
  onStatusChange: (newValue: number) => void;
  onClearFilter: () => void;
};

export const Header = ({
  area,
  status,
  onAreaChange,
  onStatusChange,
  onClearFilter,
}: Props) => {

  const handleStatusChange = useCallback((e: SelectChangeEvent<number>) => {
    onStatusChange(typeof e.target.value === 'string' ? Number(e.target.value) : e.target.value);
  }, [
    onStatusChange,
  ]);

  return (
    <CascateList title="Filtros" defaultOpen>
      <div className="w-full flex flex-col gap-6 items-center justify-center">
        <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 grid-flow-row-dense">

          <div className="2xl:col-span-2">
            <DefaultInput
              label="Área"
              name="area"
              value={area ?? ""}
              onChangeValue={onAreaChange}
            />
          </div>

          <FormControl size="small" fullWidth>
            <InputLabel id="modulo-dashboard">
              Status
            </InputLabel>
            <Select
              labelId="modulo-dashboard"
              label="Status"
              value={status}
              onChange={handleStatusChange}>
              <MenuItem value={2}>Todos</MenuItem>
              <MenuItem value={0}>Em Aberto</MenuItem>
              <MenuItem value={1}>Finalizado</MenuItem>
            </Select>
          </FormControl>
        </div>

        <div className="w-full flex justify-end">
          <div className="w-[180px]">
            <PrimaryButton
              startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
              buttonColor="yellow"
              onClick={onClearFilter}>
              Limpar filtros
            </PrimaryButton>
          </div>
        </div>
      </div>
    </CascateList>
  );
}